import React, { useState,useEffect,useRef,useMemo,useCallback} from 'react';
import { Link,Navigate, useNavigate,useParams,useLocation  } from 'react-router-dom';

// custom functions 
import { overlayStyle, loaderStyle } from './LoaderStyleCss';

// images
import Logo from '../assets/images/logo.png';
import Indiamap from "../assets/images/india.svg";
import International from "../assets/images/International.svg";
import Radiounselected from "../assets/images/Radiounselected.svg";
import Radioselected from "../assets/images/Radioselected.svg";
import Lightbulb from "../assets/images/Lightbulb.svg";
import SellerImage from "../assets/images/seller.png";
import BuyerImage from "../assets/images/buyer.png";
import Buy_sellImage from "../assets/images/buy_sell.png";
import UIImage from "../assets/images/UI.png";
import EasyImage from "../assets/images/easy.png";
import DatabaseImage from "../assets/images/database.png";
import sidebarLogo from "../assets/images/logo.svg";

import Dashboard from "../assets/images/dashboard.svg";
import Category from "../assets/images/category.svg";
import Products from "../assets/images/products.svg";
import Orders from "../assets/images/order.svg";
import Distributor from "../assets/images/distributor.svg";
import customer from "../assets/images/customer.svg";
import Users from "../assets/images/users.svg";
import Acitivity from "../assets/images/activity.svg";
import Reports from "../assets/images/report.svg";
import Accounts from "../assets/images/account.svg";
import Settings from "../assets/images/setting.svg";
import Help from "../assets/images/help.svg";
import Documentation from "../assets/images/documentation.svg";
import UserPhoto from "../assets/images/userphoto.svg";
import Upgrade from "../assets/images/upgrade.svg";
import Notification from "../assets/images/notification.svg";
import Invitations from "../assets/images/invitation.svg";
import Indiacirclelogo from "../assets/images/Indiacirclelogo.svg";
import Check from "../assets/images/check.svg";
import noDatapng from '../assets/images/noData.png';
import xlsimg from '../assets/images/xls.png';
import Noacountexist from '../assets/images/Noacountexist.svg'
import team from '../assets/images/team.png';
import noUser from '../assets/images/noUser.png';

import Axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Select from "react-select";
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-image-crop/dist/ReactCrop.css';
import moment from "moment";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { useDropzone } from 'react-dropzone';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { FaBars,FaEdit,FaArrowAltCircleRight,FaUser,FaUserAlt,FaEye,FaEyeSlash,FaPencilAlt, FaTrash, FaExchangeAlt,FaTimes, FaFileDownload, FaFileExcel, FaFilter, FaPlusCircle, FaSearch,FaMobileAlt,FaBoxOpen,FaFileImage,FaCheck,FaLock,FaPencilRuler,FaRupeeSign,FaPlus,FaPercentage,FaBuilding, FaEtsy, FaLink, FaMapMarkerAlt,FaChevronLeft,FaChevronRight,FaFilePdf,FaFolderOpen,FaRegUserCircle,FaPowerOff,FaInfo,FaUserTie,FaFileAlt,FaPhoneAlt,FaCartPlus,FaSortDown, FaFileWord, FaFilePowerpoint,FaAngleDown,FaEnvelope,FaFolder,FaCog,FaQuestionCircle,FaSignOutAlt } from "react-icons/fa";
import { FiDownload, FiTrash2, FiFile, FiImage, FiFileText,FiHome } from 'react-icons/fi';
import { BiCategory,BiChevronDown,BiRupee,BiDotsVerticalRounded,BiCheck,BiRightArrowAlt,BiMessageAltError,BiEditAlt  } from 'react-icons/bi';

import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { BsArrowLeftCircleFill ,BsCart3,BsThreeDotsVertical,BsFillPersonLinesFill,BsArrowRightShort,BsSortUpAlt} from "react-icons/bs";

import { IoMdSettings } from "react-icons/io";
import { MdLock, MdErrorOutline,MdArrowDownward,MdEmail,MdDomainVerification,MdInfo,MdDelete,MdPriceChange,MdRefresh,MdClose} from "react-icons/md";
import { RiDragMove2Line } from "react-icons/ri";
import { TbNumbers, TbUsers,TbTriangleSquareCircle } from 'react-icons/tb';


moment().format();
export{ 
    useState,useEffect,useRef,useLocation,useMemo,useCallback,
    Link,Navigate, useNavigate,useParams,
    Axios,ToastContainer, toast,uuidv4,Select,moment,Tippy,DataTable,useDropzone,CKEditor,ClassicEditor,Slider,
    overlayStyle, loaderStyle,
    AiOutlineLoading3Quarters,
    BiCategory,BiCheck,BiRightArrowAlt,BiMessageAltError,BiChevronDown,BiRupee,BiEditAlt ,
    BsFillPersonLinesFill,BsArrowLeftCircleFill,BsCart3,BsArrowRightShort,BsThreeDotsVertical,BsSortUpAlt,
    FiDownload, FiTrash2, FiFile, FiImage, FiFileText,FiHome,
    FaUserAlt,FaEyeSlash,FaBuilding,FaEtsy,FaLink,FaMapMarkerAlt,FaPowerOff,FaInfo,FaUserTie,FaSearch,FaFileExcel,FaPlusCircle,FaPlus,FaSortDown ,FaRegUserCircle,FaBars,FaFileWord, FaFilePowerpoint,
    FaEye,FaFilter,FaPencilAlt,FaTrash,FaArrowAltCircleRight,FaPercentage,FaLock,FaBoxOpen,FaPencilRuler,FaFileAlt,FaFileImage,FaFilePdf,FaFolderOpen,FaAngleDown,FaUser,FaEnvelope,FaFolder,FaCog,FaQuestionCircle,FaSignOutAlt,
    FaCheck,FaPhoneAlt,FaCartPlus,FaRupeeSign,FaTimes,
    IoMdSettings,
    MdErrorOutline,MdLock,MdEmail,FaMobileAlt,MdArrowDownward,MdInfo,MdDomainVerification ,MdRefresh,MdClose,
    TbNumbers,TbUsers,TbTriangleSquareCircle,
    RiDragMove2Line,
    Logo,Indiamap,International,Radiounselected,Radioselected,Lightbulb,xlsimg,
    SellerImage,BuyerImage,Buy_sellImage,UIImage,EasyImage,DatabaseImage,sidebarLogo,noUser,
    Invitations,Notification,Upgrade,
    Dashboard,Category,Products,Orders,Distributor,customer,Users,Reports,Accounts,Settings,Help,Documentation,UserPhoto,
    Indiacirclelogo,Check,noDatapng,Noacountexist,team
}
